<template>
	<div class="v-pagination" @scroll="scroll">
		<slot :page="page"/>
		<slot name="pager" :page="page"/>
	</div>
</template>

<script>
export default {
  props: {
    index: {
      default: 1
    },
    size: {
      default: 10
    },
    total: {
      default: 0
    }
  },
  data() {
    return {
      old: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {
    page() {
      return {
        index: this.index,
        size: this.size,
        total: this.total,
        count: Math.ceil(this.total / this.size)
      };
    }
  },
  methods: {
    scroll() {
      let {
          scrollTop,
          scrollLeft,
          scrollWidth,
          scrollHeight,
          clientWidth,
          clientHeight
        } = this.$el,
        width = scrollWidth - clientWidth,
        height = scrollHeight - clientHeight,
        e = {
          x: {
            state:
              width == 0
                ? "none"
                : scrollLeft == 0
                  ? "left"
                  : scrollLeft >= width ? "right" : "middle",
            value: scrollLeft
          },
          y: {
            state:
              height == 0
                ? "none"
                : scrollTop == 0
                  ? "top"
                  : scrollTop >= height ? "bottom" : "middle",
            value: scrollTop
          }
        };
      if (["left", "right"].includes(e.x.state)) {
        this.$emit(`scroll-${e.x.state}`, e.x);
        this.old.width = e.x.state == "left" ? width : 0;
      }
      if (["top", "bottom"].includes(e.y.state)) {
        this.$emit(`scroll-${e.y.state}`, e.y);
        this.old.height = e.y.state == "top" ? height : 0;
      }
      this.$emit("scroll", e);
    }
  },
  updated() {
    let { scrollWidth, scrollHeight, clientWidth, clientHeight } = this.$el;
    if (this.old.width) {
      this.$el.scrollLeft = scrollWidth - clientWidth - this.old.width;
    }
    if (this.old.height) {
      this.$el.scrollTop = scrollHeight - clientHeight - this.old.height;
    }
  }
};
</script>

<style lang="less">
.v-pagination {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/pagination/index.vue